import { FC, ReactNode, RefObject, useRef } from "react";
import { useOnClickOutside } from "src/hooks/useOnClickOutside";

interface Props {
  handler: () => void;
  outerRef?: RefObject<HTMLDivElement>;
  children: ReactNode;
}

const OutsideClickableBox: FC<Props> = ({
  handler,
  outerRef,
  children,
  ...rest
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  useOnClickOutside(outerRef || ref, handler);
  return (
    <div ref={ref} {...rest}>
      {children}
    </div>
  );
};

export { OutsideClickableBox };
